<template>
  <card-dialog
    v-model="modalVisible"
    max-width="400px"
    :title="$t('card_title.select_language')"
  >
    <v-card-text
      class="pa-6"
    >
      <v-row
        class="flex-column"
        align="center"
      >
        <v-col
          v-for="language in filteredLanguages"
          :key="language.code"
          class="py-2"
        >
          <v-btn
            block
            text
            class="text-none justify-start"
            :outlined="selectedLanguage === language.code"
            :style="{
              borderColor: selectedLanguage === language.code ? 'var(--v-primary-base)' : 'transparent',
              color: selectedLanguage === language.code ? 'var(--v-primary-base)' : ''
            }"
            @click="changeLanguage(language.code)"
          >
            <country-flag
              v-if="language.code"
              class="my-1 mr-1"
              :country="flags[language.code]"
              rounded
            />
            {{ language.name }}
            <v-spacer />
            <v-icon
              v-if="selectedLanguage === language.code"
            >
              fa-light fa-check
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import { EventBus } from '@/plugins/bus'
import i18n from '@/plugins/i18n'
import { EventTypeApiService } from '@/data/services'
import { applyBackendEventTypes } from '@/data/models/Event'

export default {
  name: 'ChangeLanguageDialog',
  components: { CardDialog },
  props: {
    location: {
      type: Object,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedLanguage: localStorage.getItem('user-locale') || 'en',
      languages: [
        { name: 'Deutsch', code: 'de' },
        { name: 'English', code: 'en' },
        { name: 'Español', code: 'es' },
        { name: 'Hrvatski', code: 'hr' },
        { name: 'Pусский', code: 'ru' },
        { name: 'Türkçe', code: 'tr' },
        { name: 'Čeština', code: 'cs' },
        { name: 'Български', code: 'bg' }
      ],
      flags: {
        en: 'gb',
        ru: 'ru',
        de: 'de',
        es: 'es',
        tr: 'tr',
        hr: 'hr',
        cs: 'cz',
        bg: 'bg'
      }
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    filteredLanguages() {
      return this.languages.filter(lang => {
        if (!this.user.organisation_settings.restricted_locales) return true
        return !this.user.organisation_settings.restricted_locales.includes(lang.code)
      })
    }
  },
  created() {
    EventBus.$on(this.$events.OPEN_DIALOG_CHANGE_LANGUAGE, () => {
      this.modalVisible = true
    })
  },
  methods: {
    changeLanguage(lang) {
      this.selectedLanguage = lang
      if (this.selectedLanguage !== i18n.locale) {
        i18n.locale = this.selectedLanguage
        localStorage.setItem('user-locale', this.selectedLanguage)
        // Refresh backend-served event-type labels for the new locale so they
        // update mid-session even if the reload below is a no-op.
        EventTypeApiService.getAll(this.selectedLanguage)
          .then(list => applyBackendEventTypes(list))
          .catch(() => { /* keep current labels */ })
        this.$router.go(0)
      }
    }
  }
}
</script>
